import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  input: {
    height: 86,
  },

  suggestionList: {
    "&>ul:not(:hover):not(:focus-within)>li:first-child": {
      backgroundColor: theme.hv.palette.atmosphere.atmo3,
    },
  },
}));

export default useStyles;
